import React from 'react';
import { t, L as Loader } from './index-84704ba0.js';

var s = {"content":"_h-content-2fde","statusWrapper":"_h-statusWrapper-869d","product":"_h-product-cd53","advantage":"_h-advantage-7d18","emptyLabel":"_h-emptyLabel-1f21","logoPriceClub":"_h-logoPriceClub-ffd3","percent":"_h-percent-5f73","noPadding":"_h-noPadding-b564","membership":"_h-membership-e692","deleteIcon":"_h-deleteIcon-d506","picProduct":"_h-picProduct-fce7","warranty":"_h-warranty-2883","labelTotal":"_h-labelTotal-fd44","bt":"_h-bt-8364"};

// Librairies
// Render
var CartLoader = function () { return (React.createElement("div", { className: "".concat(t['dark-gray'], " ").concat(s.content, " ").concat(t.flex, " ").concat(t['justify-center']) },
    React.createElement(Loader, null))); };

export { CartLoader as C, s };
